import { makeStyles } from '@material-ui/core';

import { RoyalBlue, White } from 'styles/colors';

export default makeStyles({
  loader: {
    color: ({ isWhite }) => (isWhite ? White : RoyalBlue),
  },
});
